import { render, staticRenderFns } from "./datasetTotals.vue?vue&type=template&id=781b7c39&scoped=true"
import script from "./datasetTotals.vue?vue&type=script&lang=js"
export * from "./datasetTotals.vue?vue&type=script&lang=js"
import style0 from "./datasetTotals.vue?vue&type=style&index=0&id=781b7c39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781b7c39",
  null
  
)

export default component.exports